export function centerOfTwoPoints(point1, point2) {
  const centerX = (point1[0] + point2[0]) / 2;
  const centerY = (point1[1] + point2[1]) / 2;
  return [centerX, centerY];
}

export function computeCOMTwoD(frame, jsonData) {
  let com = [];

  function MultiplyVector(vector, scalar) {
    return [vector[0] * scalar, vector[1] * scalar];
  }

  function addVectors(vector1, vector2) {
    return [vector1[0] + vector2[0], vector1[1] + vector2[1]];
  }

  function SubtractVectors(a, b) {
    let result = [];
    for (let i = 0; i < a.length; i++) {
      result.push(a[i] - b[i]);
    }
    return result;
  }

  for (let i = 0; i < jsonData[frame][0].length; i++) {
    const pelvis = jsonData[frame][0];
    const hip_r = jsonData[frame][1];
    const knee_r = jsonData[frame][2];
    const ankle_r = jsonData[frame][3];
    const foot_r = jsonData[frame][4];
    const hip_l = jsonData[frame][6];
    const knee_l = jsonData[frame][7];
    const ankle_l = jsonData[frame][8];
    const foot_l = jsonData[frame][9];
    const shoulder_r = jsonData[frame][14];
    const elbow_r = jsonData[frame][15];
    const wrist_r = jsonData[frame][16];
    const hand_r = jsonData[frame][17];
    const shoulder_l = jsonData[frame][18];
    const elbow_l = jsonData[frame][19];
    const wrist_l = jsonData[frame][20];
    const hand_l = jsonData[frame][21];
    const neck = jsonData[frame][22];
    const skullbase = jsonData[frame][23];
    const skull = jsonData[frame][24];

    // Compute center of mass of each segment
    let V, factor;

    // Head
    V = [skull[0] - skullbase[0], skull[1] - skullbase[1]];
    factor = 0.5976;
    let head_COM = [skull[0] - V[0] * factor, skull[1] - V[1] * factor];

    // Trunk
    V = [neck[0] - pelvis[0], neck[1] - pelvis[1]];
    factor = 0.4486;
    let trunk_COM = [neck[0] - V[0] * factor, neck[1] - V[1] * factor];

    // Right Arm
    V = [shoulder_r[0] - elbow_r[0], shoulder_r[1] - elbow_r[1]];
    factor = 0.5772;
    let arm_r_COM = [
      shoulder_r[0] - V[0] * factor,
      shoulder_r[1] - V[1] * factor,
    ];

    V = [elbow_r[0] - wrist_r[0], elbow_r[1] - wrist_r[1]];
    factor = 0.4574;
    let forearm_r_COM = [
      elbow_r[0] - V[0] * factor,
      elbow_r[1] - V[1] * factor,
    ];

    V = [wrist_r[0] - hand_r[0], wrist_r[1] - hand_r[1]];
    factor = 0.79;
    let hand_r_COM = [wrist_r[0] - V[0] * factor, wrist_r[1] - V[1] * factor];

    // Left Arm
    let Varm_l_COM = SubtractVectors(shoulder_l, elbow_l);
    let factorarm_l_COM = 0.5772;
    let arm_l_COM = SubtractVectors(
      shoulder_l,
      MultiplyVector(Varm_l_COM, factorarm_l_COM)
    );

    let Vforearm_l_COM = SubtractVectors(elbow_l, wrist_l);
    let factorforearm_l_COM = 0.4574;
    let forearm_l_COM = SubtractVectors(
      elbow_l,
      MultiplyVector(Vforearm_l_COM, factorforearm_l_COM)
    );

    let Vhand_l_COM = SubtractVectors(wrist_l, hand_l);
    let factorhand_l_COM = 0.79;
    let hand_l_COM = SubtractVectors(
      wrist_l,
      MultiplyVector(Vhand_l_COM, factorhand_l_COM)
    );

    // Right Thigh
    let VThighRCOM = SubtractVectors(hip_r, knee_r);
    let factorThighRCOM = 0.4095;
    let thigh_r_COM = SubtractVectors(
      hip_r,
      MultiplyVector(VThighRCOM, factorThighRCOM)
    );

    let Vshank_r_COM = SubtractVectors(knee_r, ankle_r);
    let factorshank_r_COM = 0.4459;
    let shank_r_COM = SubtractVectors(
      knee_r,
      MultiplyVector(Vshank_r_COM, factorshank_r_COM)
    );

    let Vfoot_r_COM = SubtractVectors(ankle_r, foot_r);
    let factorfoot_r_COM = 0.4415;
    let foot_r_COM = SubtractVectors(
      ankle_r,
      MultiplyVector(Vfoot_r_COM, factorfoot_r_COM)
    );

    // Left Thigh
    let Vthigh_l_COM = SubtractVectors(hip_l, knee_l);
    let factorthigh_l_COM = 0.4095;
    let thigh_l_COM = SubtractVectors(
      hip_l,
      MultiplyVector(Vthigh_l_COM, factorthigh_l_COM)
    );

    let Vshank_l_COM = SubtractVectors(knee_l, ankle_l);
    let factorshank_l_COM = 0.4459;
    let shank_l_COM = SubtractVectors(
      knee_l,
      MultiplyVector(Vshank_l_COM, factorshank_l_COM)
    );

    let Vfoot_l_COM = SubtractVectors(ankle_l, foot_l);
    let factorfoot_l_COM = 0.4415;
    let foot_l_COM = SubtractVectors(
      ankle_l,
      MultiplyVector(Vfoot_l_COM, factorfoot_l_COM)
    );

    // Compute mass (%) of each segment
    let head_m = 6.94 / 100;
    let trunk_m = 43.36 / 100;
    let arm_r_m = 2.71 / 100;
    let forearm_r_m = 1.62 / 100;
    let hand_r_m = 0.61 / 100;
    let thigh_r_m = 14.16 / 100;
    let shank_r_m = 4.33 / 100;
    let foot_r_m = 1.37 / 100;
    let arm_l_m = 2.71 / 100;
    let forearm_l_m = 1.62 / 100;
    let hand_l_m = 0.61 / 100;
    let thigh_l_m = 14.16 / 100;
    let shank_l_m = 4.33 / 100;
    let foot_l_m = 1.37 / 100;

    // Compute normal center of mass
    let val1 = MultiplyVector(head_COM, head_m);
    let val2 = MultiplyVector(trunk_COM, trunk_m);
    let val3 = MultiplyVector(arm_r_COM, arm_r_m);
    let val4 = MultiplyVector(forearm_r_COM, forearm_r_m);
    let val5 = MultiplyVector(hand_r_COM, hand_r_m);
    let val6 = MultiplyVector(thigh_r_COM, thigh_r_m);
    let val7 = MultiplyVector(shank_r_COM, shank_r_m);
    let val8 = MultiplyVector(foot_r_COM, foot_r_m);
    let val9 = MultiplyVector(arm_l_COM, arm_l_m);
    let val10 = MultiplyVector(forearm_l_COM, forearm_l_m);
    let val11 = MultiplyVector(hand_l_COM, hand_l_m);
    let val12 = MultiplyVector(thigh_l_COM, thigh_l_m);
    let val13 = MultiplyVector(shank_l_COM, shank_l_m);
    let val14 = MultiplyVector(foot_l_COM, foot_l_m);

    const vectorsToSum = [
      val1,
      val2,
      val3,
      val4,
      val5,
      val6,
      val7,
      val8,
      val9,
      val10,
      val11,
      val12,
      val13,
      val14,
    ];

    com = vectorsToSum.reduce((accumulator, currentValue) =>
      addVectors(accumulator, currentValue)
    );
  }

  return com;
}

export const drawLine = (context, x1, y1, x2, y2, strokeColor) => {
  context.beginPath();
  context.moveTo(x1, y1);
  context.lineTo(x2, y2);
  context.lineWidth = 2;
  context.strokeStyle = strokeColor || "red";
  context.stroke();
};

export function isValueExistAfterP7(clubTracer, positions) {
  if (positions) {
    const startIndex = positions["P7"];
    let hasValueAfterP7 = false;

    for (const key in clubTracer?.data?.ball) {
      if (parseInt(key) > startIndex && clubTracer?.data?.ball[key] !== null) {
        hasValueAfterP7 = true;
        break;
      }
    }

    if (hasValueAfterP7) {
      return true;
    } else {
      return false;
    }
  }
}
export function drawEquilateralTriangle(context, x, y, sideLength, color) {
  const height = (Math.sqrt(3) / 2) * sideLength; // Height of an equilateral triangle
  const x1 = x - sideLength / 2;
  const y1 = y + height / 2;
  const x2 = x + sideLength / 2;
  const y2 = y + height / 2;
  const x3 = x;
  const y3 = y - height / 2;

  context.beginPath();
  context.moveTo(x1, y1);
  context.lineTo(x2, y2);
  context.lineTo(x3, y3);
  context.closePath();

  // Fill the triangle with a color
  context.fillStyle = color; // Change the color as needed
  context.fill();
  // Optionally, you can add a border to the triangle
  context.strokeStyle = color; // Change the border color as needed
  context.lineWidth = 2; // Adjust the border width as needed
  context.stroke(); // Stroke the triangle outline
}

export const appColors = {
  yellow: "#f4b821",
  blue: "#006ab3",
  green: "#7bb728",
  darkYellow: "#B78E00",
  darkGreen: "#629220",
};

export const forceVectorsDrawing = ({
  canvasRef,
  cvData,
  forceVectors,
  loading,
  sameVideo,
  currentFrameForSameVideo,
  currentFrame,
  type,
  videoParentHeight,
  videoParentWidth,
  visualizeContainerHeight,
  visualizeContainerWidth,
}) => {
  const canvas = canvasRef.current;
  const context = canvas.getContext("2d");
  const videoWidth = cvData?.configuration.video.width;
  const videoHeight = cvData?.configuration.video.height;
  const isTwoCavas = type === "twoD";

  const getScaledX = (xCoordinate) => {
    const scalingXForTwoDCanvas =
      (xCoordinate / videoWidth) * visualizeContainerWidth;
    const scalingXForVideo = xCoordinate * (videoParentWidth / videoWidth);
    const scaledX = isTwoCavas ? scalingXForTwoDCanvas : scalingXForVideo;
    return scaledX;
  };
  const getScaledY = (yCoordinate) => {
    const scalingYForTwoDCanvas =
      (yCoordinate / videoHeight) * visualizeContainerHeight;
    const scalingYForVideo = yCoordinate * (videoParentHeight / videoHeight);
    const scaledY = isTwoCavas ? scalingYForTwoDCanvas : scalingYForVideo;
    return scaledY;
  };

  if (forceVectors && !loading) {
    const leftForceVector = forceVectors?.force_vector_l_2d;
    const rightForceVector = forceVectors?.force_vector_r_2d;
    const centeredForceVector = forceVectors?.force_vector_c_2d;

    const leftStartX =
      leftForceVector?.start_point_X_l_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const leftStartY =
      leftForceVector?.start_point_Y_l_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const leftEndX =
      leftForceVector?.end_point_X_l_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const leftEndY =
      leftForceVector?.end_point_Y_l_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];

    const rightStartX =
      rightForceVector?.start_point_X_r_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const rightStartY =
      rightForceVector?.start_point_Y_r_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const rightEndX =
      rightForceVector?.end_point_X_r_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const rightEndY =
      rightForceVector?.end_point_Y_r_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];

    const centeredStartX =
      centeredForceVector?.start_point_X_combined_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const centeredStartY =
      centeredForceVector?.start_point_Y_combined_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const centeredEndX =
      centeredForceVector?.end_point_X_combined_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];
    const centeredEndY =
      centeredForceVector?.end_point_Y_combined_2d[
        sameVideo ? currentFrameForSameVideo : currentFrame
      ];

    context.clearRect(0, 0, canvas.width, canvas.height);

    drawEquilateralTriangle(
      context,
      getScaledX(centeredEndX),
      getScaledY(centeredEndY),
      15,
      appColors.blue
    );
    drawEquilateralTriangle(
      context,
      getScaledX(leftEndX),
      getScaledY(leftEndY),
      15,
      appColors.yellow
    );
    drawEquilateralTriangle(
      context,
      getScaledX(rightEndX),
      getScaledY(rightEndY),
      15,
      appColors.green
    );

    // --------------------------- left foot
    drawLine(
      context,
      getScaledX(leftStartX),
      getScaledY(leftStartY),
      getScaledX(leftEndX),
      getScaledY(leftEndY),
      appColors.yellow
    );

    // ----------------- right foot

    drawLine(
      context,
      getScaledX(rightStartX),
      getScaledY(rightStartY),
      getScaledX(rightEndX),
      getScaledY(rightEndY),
      appColors.green
    );

    // -------------------- centered

    drawLine(
      context,
      getScaledX(centeredStartX),
      getScaledY(centeredStartY),
      getScaledX(centeredEndX),
      getScaledY(centeredEndY),
      appColors.blue
    );
  }
};
